export const getSingleOrDefault = <T>(items: T[], duplicatedErrorMessage?: string): T | undefined => {
    if (items.length === 1) {
        return items[0];
    }
    if (items.length === 0) {
        return undefined;
    }

    throw new Error(duplicatedErrorMessage ?? "Duplicated item.");
};

export const getSingle = <T>(items: T[], missingErrorMessage?: string, duplicatedErrorMessage?: string): T => {
    if (!items.length) {
        throw new Error(missingErrorMessage ?? "Missing item.");
    }

    if (items.length > 1) {
        throw new Error(duplicatedErrorMessage ?? "Duplicated item.");
    }

    return items[0];
};
